"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressFactory = void 0;
const Factory = require("factory.ts");
exports.addressFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    street_1: '1234 Main St',
    street_2: null,
    zip: '55555',
    city: 'Minneapolis',
    state_or_province: 'MN',
    country: 'US'
});
